import React from 'react';

import './style.scss';

interface UnreadBadgeProps {
  unreadCount?: number;
  unreadText?: string;
  squished?: boolean;
  style?: React.CSSProperties;
  className?: string;
  backgroundColor?: string;
}

const UnreadBadge: React.FC<UnreadBadgeProps> = ({
  unreadCount,
  unreadText,
  squished,
  style = {},
  className = '',
  backgroundColor,
}) => {
  const badgeStyle = backgroundColor ? { ...style, backgroundColor } : style;

  return (
    <>
      {unreadCount !== undefined && unreadCount >= 1 && (
        <div
          className={`unread-badge ${squished ? 'squished' : ''} ${className}`}
          style={badgeStyle}
        >
          <span key={unreadCount}>{unreadCount >= 100 ? '99+' : unreadCount}</span>
        </div>
      )}
      {!!unreadText && (
        <div
          className={`unread-badge ${squished ? 'squished' : ''} ${className}`}
          style={badgeStyle}
        >
          <span key={unreadText}>{unreadText}</span>
        </div>
      )}
    </>
  );
};

export default UnreadBadge;
